import { type IXSLXImport } from '@principle-theorem/shared';
import type { Row } from 'exceljs';
import {
  type IPaymentMethodXSLX,
  PAYMENT_METHOD_HEADERS,
} from './payment-method-to-xlsx';

export class XSLXToPaymentMethod implements IXSLXImport<IPaymentMethodXSLX> {
  headers = PAYMENT_METHOD_HEADERS;

  translate(row: Row): IPaymentMethodXSLX {
    return {
      sourceId: row.getCell('sourceId').value?.toString() ?? '',
      sourceName: row.getCell('sourceName').value?.toString() ?? '',
      mapTo: row
        .getCell('mapTo')
        .value?.toString() as IPaymentMethodXSLX['mapTo'],
    };
  }
}
